export default function assert(message, check) {
  if (!check) {
    throw new Error(message)
  }
}
